import moment from 'moment';

export const dotCodePattern = /\w+-\w{3}([0-5][0-9])(\d{2})/i;
export const dotCodePattern2 = /\w{3}\s\w{6}\s([0-5][0-9])(\d{2})/i;

export const checkDotDate = (value, saleDateRaw) => {
  if (!value) {
    return false;
  }
  let date = value.match(dotCodePattern);

  if (!date) {
    date = value.match(dotCodePattern2);
    if (!date) {
      return false;
    }
  }
  const year = `20${date[2]}`;
  const week = +date[1];
  const dateDot = moment().endOf('day').endOf('week');
  const saleDate = moment(saleDateRaw, 'DD.MM.YYYY').endOf('day');
  dateDot.year(+year);
  dateDot.week(week);
  return saleDate.diff(dateDot, 'years', true);
};

export const checkSoldOn = (value) => {
  if (!value) {
    return false;
  }
  const soldOn = moment(value, 'DD.MM.YYYY').endOf('day');
  const now = moment().endOf('day');

  if (!soldOn.isValid()) {
    return false;
  }
  return now.diff(soldOn, 'years', true);
};
